@if (!isAuthenticated) {
  <xui-loading></xui-loading>
}
@if (isAuthenticated) {
  <app-authenticated></app-authenticated>
}
@if (offlineAlertVisible) {
  <xui-banner [useOverlay]="true" bgColorClass="error" message="Your device is offline. Please check your internet connection to continue using this app"></xui-banner>
}
@if (errorAlertVisible) {
  <xui-banner [useOverlay]="true" bgColorClass="error" message="The application has encountered an issue and is unable to load. You can try reloading or contact support." primaryActionText="Contact Support" secondaryActionText="Reload" (primaryAction)="reload()" (secondaryAction)="reload()"></xui-banner>
}
@if (updateAlertVisible) {
  <xui-banner bgColorClass="dark" message="This application has been updated. Please reload to get the latest features." primaryActionText="Reload" secondaryActionText="Dismiss" (primaryAction)="reload()" (secondaryAction)="updateAlertVisible=false"></xui-banner>
}
